import React, { useEffect, useState } from 'react'
import { supabase } from '../../utils/supabaseClient'
import { City } from '../../utils/types'
import NewsBlock from "../newsBlock/newsBlock";
import Header from "../header/header";

const LibraryPage: React.FC = () => {
	const [cities, setCities] = useState<City[]>([])
	const [loading, setLoading] = useState(true)

	const getCitiesAndCountries = async () => {
		try {
			const { data, error } = await supabase.from('cities').select(`
                    *,
                    city2country (
                        fk_country,
                        countries (
                            id,
                            created_at,
                            country
                        )
                    )
                `)

			if (error) {
				throw error
			}

			// Transform data to fit the City type
			const transformedData = data.map((city: any) => ({
				...city,
				countries: city.city2country.map((c2c: any) => ({
					id: c2c.countries.id,
					created_at: c2c.countries.created_at,
					country: c2c.countries.country,
				})),
			}))

			setCities(transformedData as City[]) // Type cast to City[]
		} catch (error) {
			console.error('Error fetching data:', (error as Error).message)
		} finally {
			setLoading(false) // Set loading to false once the data is fetched
		}
	}

	useEffect(() => {
		getCitiesAndCountries()
	}, [])

	return (
		<>
			<Header title={'Library'} />

			<main>
				<NewsBlock/>
				<h1>City and Country List</h1>
				{loading ? (
					<p>Loading...</p>
				) : (
					<ul>
						{cities.map((city) => (
							<li key={city.id}>
								{city.city}
								{city.countries && city.countries.length > 0 && (
									<span>
										:{' '}
										{city.countries.map((country) => country.country).join(', ')}
									</span>
								)}
							</li>
						))}
					</ul>
				)}
			</main>
		</>
	)
}

export default LibraryPage
